import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { isCountryCode } from '@/types/CountryCode';
export function useActiveCountryCode() {
  const $ = _c(2);
  const route = useParams();
  const countryCode = route.slug?.[0];
  let t0;
  if ($[0] !== countryCode) {
    t0 = isCountryCode(countryCode) ? countryCode : undefined;
    $[0] = countryCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}